import isServer from "@utils/is-server";

export function calculateNextImageSizesByDevice(device) {
  if (isServer()) return "320px";

  switch (device) {
    case "mobile":
      // 2 columns
      // < 439px : 192px,
      // 440px to 767px : 256px,
      // 768px to 991px : 384px
      return "(max-width: 439px) 192px, (max-width: 767px) 256px, (max-width: 991px) 384px";

    case "desktop":
      // 4 columns
      // 992px to 1199px : 256px,
      // 1200px to 1399px : 320px,
      // >= 1400px : 320px
      return "(max-width: 1199px) 256px, 320px";

    default:
      return "448px";
  }
}
